import { SvgWrapper } from 'src/svgs/SvgWrapper';

import { IconsProps } from '../icon-types';

export function DownRightArrowIcon(props: IconsProps) {
  return (
    <SvgWrapper {...props} viewBox="0 0 8 8">
      <path
        fill="inherit"
        d="M8 1.667v5.833A.5.5 0 0 1 7.5 8H1.667a.5.5 0 1 1 0-1h4.626L.146.853a.5.5 0 0 1 .707-.707L7 6.293V1.667a.5.5 0 1 1 1 0"
      />
    </SvgWrapper>
  );
}
